'use client'

import {createContext, useContext, useState, FC, ReactNode} from 'react'

interface DominoContextProps {
  isDominoVisible: boolean
  setDominoVisibility: (visibility: boolean) => void
  retryGame: boolean
  setRetryGame: (retry: boolean) => void
}

const DominoContext = createContext<DominoContextProps | undefined>(undefined)

export const DominoProvider: FC<{children: ReactNode}> = ({children}) => {
  const [isDominoVisible, setDominoVisibility] = useState(false)
  const [retryGame, setRetryGame] = useState(false)

  return (
    <DominoContext.Provider value={{isDominoVisible, setDominoVisibility, retryGame, setRetryGame}}>
      {children}
    </DominoContext.Provider>
  )
}

export const useDomino = () => {
  const context = useContext(DominoContext)
  if (context === undefined) {
    throw new Error('useDomino must be used within a DominoProvider')
  }
  return context
}
